// Página de Contacto - Contact Page
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: 'general',
        message: ''
    });
    const [status, setStatus] = useState({ type: '', message: '' });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setStatus({ type: '', message: '' });

        // Simulación de envío - En producción conectar con backend/email service
        try {
            await new Promise(resolve => setTimeout(resolve, 1500));
            
            // Aquí iría la lógica real de envío
            console.log('Formulario enviado:', formData);
            
            setStatus({
                type: 'success',
                message: '¡Mensaje enviado correctamente! Te responderemos lo antes posible.'
            });
            setFormData({ name: '', email: '', subject: 'general', message: '' });
        } catch (error) {
            setStatus({
                type: 'error',
                message: 'Error al enviar el mensaje. Por favor, inténtalo de nuevo.'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="legal-container">
            <nav className="legal-nav">
                <Link to="/" className="legal-back">← Volver al inicio</Link>
                <Link to="/" className="legal-logo">
                    <div className="legal-logo-icon">⚡</div>
                    <span className="legal-logo-text">Roadmap<span>Platform</span></span>
                </Link>
            </nav>

            <header className="legal-header">
                <h1>Contacto</h1>
                <p className="legal-subtitle">¿Tienes preguntas? Estamos aquí para ayudarte</p>
            </header>

            <main className="legal-content">
                <section className="legal-section">
                    <h2>Información de contacto</h2>
                    <p>Puedes ponerte en contacto con nosotros a través de los siguientes medios:</p>
                    
                    <div className="legal-contact-card">
                        <h4>Datos de contacto</h4>
                        <div className="contact-item">
                            <span className="contact-icon">📧</span>
                            <div className="contact-info">
                                <span className="contact-label">Email de soporte</span>
                                <span className="contact-value">soporte@roadmap.fixarr.es</span>
                            </div>
                        </div>
                        <div className="contact-item">
                            <span className="contact-icon">💼</span>
                            <div className="contact-info">
                                <span className="contact-label">Email comercial</span>
                                <span className="contact-value">info@roadmap.fixarr.es</span>
                            </div>
                        </div>
                        <div className="contact-item">
                            <span className="contact-icon">🔒</span>
                            <div className="contact-info">
                                <span className="contact-label">Privacidad y RGPD</span>
                                <span className="contact-value">privacidad@roadmap.fixarr.es</span>
                            </div>
                        </div>
                        <div className="contact-item">
                            <span className="contact-icon">📍</span>
                            <div className="contact-info">
                                <span className="contact-label">Dirección</span>
                                <span className="contact-value">[DIRECCIÓN - PENDIENTE], España</span>
                            </div>
                        </div>
                    </div>

                    <div className="legal-info-box">
                        <p><strong>Horario de atención:</strong> Lunes a Viernes, 9:00 - 18:00 (hora de España peninsular). Intentamos responder en un plazo máximo de 48 horas laborables.</p>
                    </div>
                </section>

                <section className="legal-section">
                    <h2>Formulario de contacto</h2>
                    <p>Rellena el siguiente formulario y te responderemos lo antes posible.</p>
                    
                    <div className="contact-form-section">
                        {status.message && (
                            <div className={`legal-info-box ${status.type === 'error' ? 'important' : ''}`}>
                                <p>{status.message}</p>
                            </div>
                        )}
                        
                        <form className="contact-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="name">Nombre completo *</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    placeholder="Tu nombre"
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="email">Email *</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    placeholder="tu@email.com"
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="subject">Asunto *</label>
                                <select
                                    id="subject"
                                    name="subject"
                                    value={formData.subject}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="general">Consulta general</option>
                                    <option value="support">Soporte técnico</option>
                                    <option value="billing">Facturación y pagos</option>
                                    <option value="privacy">Privacidad y datos (RGPD)</option>
                                    <option value="partnership">Colaboraciones</option>
                                    <option value="bug">Reportar un error</option>
                                    <option value="feature">Sugerir una mejora</option>
                                    <option value="other">Otro</option>
                                </select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="message">Mensaje *</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                    placeholder="Describe tu consulta con el mayor detalle posible..."
                                />
                            </div>

                            <button 
                                type="submit" 
                                className="form-submit"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Enviando...' : 'Enviar mensaje'}
                            </button>
                        </form>
                    </div>
                </section>

                <section className="legal-section">
                    <h2>Preguntas frecuentes antes de contactar</h2>
                    
                    <div className="legal-contact-card">
                        <h4>¿Cómo cancelo mi suscripción?</h4>
                        <p style={{ margin: '8px 0 0', color: '#666' }}>
                            Puedes cancelar desde tu panel de configuración (Dashboard → Configuración → Suscripción → Cancelar). La cancelación será efectiva al final del periodo de facturación.
                        </p>
                    </div>

                    <div className="legal-contact-card">
                        <h4>¿Cómo elimino mi cuenta y mis datos?</h4>
                        <p style={{ margin: '8px 0 0', color: '#666' }}>
                            Según el RGPD, tienes derecho a solicitar la eliminación de tus datos. Puedes hacerlo desde Configuración o enviándonos un email a privacidad@roadmap.fixarr.es
                        </p>
                    </div>

                    <div className="legal-contact-card">
                        <h4>¿Ofrecéis reembolsos?</h4>
                        <p style={{ margin: '8px 0 0', color: '#666' }}>
                            Ofrecemos un periodo de prueba gratuito de 7 días. Tras ese periodo, no realizamos reembolsos por periodos parciales, pero puedes cancelar en cualquier momento.
                        </p>
                    </div>
                </section>

                <section className="legal-section">
                    <h2>Reportar problemas de seguridad</h2>
                    <div className="legal-info-box warning">
                        <p>
                            <strong>Vulnerabilidades de seguridad:</strong> Si descubres una vulnerabilidad de seguridad, por favor repórtala de forma responsable enviando un email a <strong>seguridad@roadmap.fixarr.es</strong>. 
                            No divulgues públicamente la vulnerabilidad hasta que hayamos tenido oportunidad de solucionarla.
                        </p>
                    </div>
                </section>
            </main>

            <footer className="legal-footer">
                <div className="legal-footer-links">
                    <Link to="/legal">Aviso Legal</Link>
                    <Link to="/privacy-policy">Política de Privacidad</Link>
                    <Link to="/cookies">Política de Cookies</Link>
                    <Link to="/terms">Términos y Condiciones</Link>
                </div>
                <p>© 2026 Roadmap Platform. Parte del ecosistema FIXARR.</p>
            </footer>
        </div>
    );
};

export default Contact;
